import BadDevNoCoffee from "./BadDevNoCoffee";
import CantReachBackend from "./CantReachBackend";
import CantReachDB from "./CantReachDB";
import ErrorWithToast from "./ErrorWithToast";
import LoginFail from "./LoginFail";
import NeedsLogin from "./NeedsLogin";
import BoletoNotFound from "./BoletoNotFound";
import BoletosOffline from "./BoletosOffline";

const errorSwitch = (e) => {
  if (e instanceof ErrorWithToast) {
    return e;
  }
  if (!e) {
    return new BadDevNoCoffee(e);
  }
  if (e.response) {
    const error = typeof e.response.data === "string" ? JSON.parse(e.response.data) : e.response.data
    const status = parseInt(e.response.status)
    if (error.errorId) {
      return backendErrors(error, status);
    }
  }
  if (e.message === 'Network Error') {
    return new CantReachBackend();
  }

  return new BadDevNoCoffee(e);
}

const backendErrors = (error, status) => {
  switch (error.errorId) {
    case "connection-error":
      return new CantReachDB();
    case "login-fail":
      return new LoginFail();
    case "user-token-absent":
      return new NeedsLogin();
    case "boleto-not-found":
      return new BoletoNotFound();
    case "boletos-offline":
      return new BoletosOffline();
    case "user-token-invalid":
      // eslint-disable-next-line no-restricted-globals
      location.assign('/logoff');
      return new Error("");
    case "user-not-found":
      return new CantReachDB();
    case "bad-token-gen":
    case "user-email-invalid":
    default:
      return new BadDevNoCoffee(error, status);
  }
}

const ErrorHandler = (err) => {
  const displayError = errorSwitch(err);
  if (displayError instanceof ErrorWithToast) {
    displayError.display();
  }
  return displayError;
}

export default ErrorHandler
